import React from 'react';
import PortalModal from './../portal-modal/./portal-modal';
// @ts-ignore
import {GetYoutubeIdFromUrl} from './../../themes/kent/utilities/functions';

// @ts-ignore
import YoutubeBackground from 'react-youtube-background'


interface IProps {
  video?:string;
  showSkipButton?:boolean;
  setCookie?:boolean;
  cookieValue?:string;
}

interface IState {
  videoCompleted?:boolean;
  activateModal?:boolean;
  videoId?:any;
}

/**
 *
 * Video Box Component
 * @extends {React.Component}
 */
class VideoIntro extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state ={
      videoCompleted:false,
      activateModal:false
    };
  }

  public componentDidMount  = async() => {
    let cookie:any = undefined;
    if(this.props.cookieValue){
      cookie = localStorage.getItem(this.props.cookieValue);
    }
    const videoId = await GetYoutubeIdFromUrl(this.props.video);

    if(this.props.setCookie && this.props.cookieValue){
      if(cookie != "true"){
        this.setState({
          videoId:videoId,
          activateModal:true,
          videoCompleted:false
        })
        localStorage.setItem(this.props.cookieValue, 'true');
      }
    } else{
      this.setState({
        videoId:videoId,
        activateModal:true,
        videoCompleted:false
      })
    }
  }

  public onVideoEnd  = () => {
    this.setState({
      videoCompleted:true
    },()=>{
      setTimeout(() => {
        this.setState({
          activateModal:false
        })
      }, 750);
    })
  }

  public render(): JSX.Element {
    let videoCompletedClass = this.state.videoCompleted ? "fade-out" : "";
    return (
      <span>
        {this.state.activateModal &&
          <PortalModal
            modalActive={this.state.activateModal}
            hideCloseButton={true}
            content={
              <div className={`video-intro-container `+videoCompletedClass}>
                {this.state.videoId &&
                  <YoutubeBackground
                    nocookie={true}
                    onEnd={this.onVideoEnd}
                    playerOptions={{
                      rel:0,
                      modestbranding:1,
                      controls:0,
                      loop:false
                    }}
                    videoId={this.state.videoId}
                    className={'video-player-container'}
                    >
                      <div style={{height:'100vh', width:'100vw'}}>
                        {this.props.showSkipButton &&
                          <div className="skip-button-container">
                            <div className="skip-button" onClick={this.onVideoEnd}>{'Skip'}</div>
                          </div>
                        }
                      </div>
                    </YoutubeBackground>
                  }
              </div>
            }
          />
        }
      </span>
    );
  }
}

export default VideoIntro;
